import { useEffect } from 'react';
import { Form, Modal, Row, Col, Input } from 'antd';
import { useTranslation } from 'react-i18next'; // Importing useTranslation

const ModalForm = ({ open, onClose, selectedItem, add, edit, title }) => {
  const { t } = useTranslation(); // Using the translation hook
  const [form] = Form.useForm();

  useEffect(() => {
    if (selectedItem) {
      form.setFieldsValue(selectedItem);
    } else {
      form.resetFields();
    }
  }, [form, selectedItem]);

  const onSubmit = async (values) => {
    let body = values;
    if (selectedItem) {
      let editBody = {};
      Object.keys(selectedItem).forEach((key) => {
        if (key in values) {
          if (selectedItem[key] !== values[key]) {
            editBody[key] = values[key] || null;
          }
        }
      });

      if (
        Object.keys(editBody).length === 0 &&
        editBody.constructor === Object
      ) {
        return;
      }
      edit(editBody);
    } else {
      add(body);
    }
  };

  return (
    <Modal
      open={open}
      forceRender
      title={
        selectedItem
          ? t('modalForm.edit', { title })
          : t('modalForm.addNew', { title })
      }
      okText={selectedItem ? t('modalForm.editButton') : t('modalForm.add')}
      cancelText={t('modalForm.cancelButton')}
      onCancel={onClose}
      onOk={() => {
        form
          .validateFields()
          .then((values) => {
            onSubmit(values);
          })
          .catch((err) => {});
      }}
    >
      <Form
        form={form}
        layout="vertical"
        name={title}
        initialValues={{
          modifier: 'public',
        }}
      >
        <Row gutter={16}>
          <Col xs={24} sm={12}>
            <Form.Item
              name="firstName"
              label={t('modalForm.firstName')}
              rules={[
                {
                  required: true,
                  message: t('form.validationMessages.requiredField', {
                    field: t('modalForm.firstName'),
                  }),
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12}>
            <Form.Item
              name="lastName"
              label={t('modalForm.lastName')}
              rules={[
                {
                  required: true,
                  message: t('form.validationMessages.requiredField', {
                    field: t('modalForm.lastName'),
                  }),
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12}>
            <Form.Item
              name="email"
              label={t('modalForm.email')}
              validateTrigger={['onBlur']}
              rules={[
                {
                  required: true,
                  type: 'email',
                  message: t('form.validationMessages.requiredField', {
                    field: t('modalForm.email'),
                  }),
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          {!selectedItem && (
            <Col xs={24} sm={12}>
              <Form.Item
                name="password"
                label={t('modalForm.password')}
                rules={[
                  {
                    required: true,
                    message: t('form.validationMessages.requiredField', {
                      field: t('modalForm.password'),
                    }),
                  },
                ]}
              >
                <Input.Password />
              </Form.Item>
            </Col>
          )}
          <Col xs={24} sm={12}>
            <Form.Item name="address" label={t('modalForm.address')}>
              <Input />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12}>
            <Form.Item name="phone" label={t('modalForm.phone')}>
              <Input />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default ModalForm;
